var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@empiriecom/module-components/utils/styled-components';
import Basic from './basic';
import ThemeDefault from './default';
import ThemeType1 from './type1';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  ", ";\n\n  ", "\n"], ["\n  ", "\n\n  ",
    ";\n\n  ",
    "\n"])), Basic, function (_a) {
    var styleType = _a.styleType;
    return styleType === 'type1' ? ThemeType1 : ThemeDefault;
}, function (_a) {
    var styleMargin = _a.styleMargin;
    return styleMargin !== '' ? "margin: " + styleMargin + ";" : '';
});
export default Wrapper;
var templateObject_1;
//# sourceMappingURL=index.js.map